import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP } from '~/lib/zod';
import z from 'zod';

export default createPerformableConfig(
  'virtual',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      photos: z.coerce.number(),
    }),
  },
  {
    name: 'Virtual Twilight',
    short:
      'We magically convert a normal day photo into a twilight image, complete with different sky, window and light effects and more.',
    tenant: TenantId.MAINE_LINE_MEDIA,
    thumbnail: 'tenant/mpi/virtual/2.jpg',
    group: 'Photo Editing',
    images: [],
  },
);
